export default __webpack_public_path__ + "static/media/Vent-A-Hood@3x.8dbcbcef.png";